import { render, staticRenderFns } from "./SidebarToolbar.vue?vue&type=template&id=720b0f2f&"
import script from "./SidebarToolbar.vue?vue&type=script&lang=ts&"
export * from "./SidebarToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720b0f2f')) {
      api.createRecord('720b0f2f', component.options)
    } else {
      api.reload('720b0f2f', component.options)
    }
    module.hot.accept("./SidebarToolbar.vue?vue&type=template&id=720b0f2f&", function () {
      api.rerender('720b0f2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarToolbar.vue"
export default component.exports